module.exports = __webpack_public_path__ + "static/media/copy.495e98db.svg";